import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";
import { BTN, INPUT, downloadIcs, errMsg, fmt } from "../../components/crm/crmUtil";

const day = (iso) => new Date(iso).toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" });

// B5: calendar list of site visits / inspections (next 30 days by default), assignee filter, iCal export.
export default function SiteVisitsCalendar() {
  const [rows, setRows] = useState(null);
  const [users, setUsers] = useState([]);
  const [assignee, setAssignee] = useState("");
  const [err, setErr] = useState("");
  const range = () => { const s = new Date(); s.setHours(0, 0, 0, 0); const e = new Date(s); e.setDate(e.getDate() + 30); return `start=${s.toISOString()}&end=${e.toISOString()}`; };
  const q = () => `${range()}${assignee ? `&assignee=${assignee}` : ""}`;
  const load = useCallback(() => api.get(`/site-visits/calendar?${q()}`).then((r) => setRows(r.data)).catch((e) => setErr(errMsg(e))), [assignee]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { load(); api.get("/crm/assignable-users?resource=site_visit").then((r) => setUsers(r.data)).catch(() => {}); }, [load]);
  const groups = (rows || []).reduce((g, v) => { (g[day(v.scheduled_at)] = g[day(v.scheduled_at)] || []).push(v); return g; }, {});
  return (
    <AppShell title="Site visits" subtitle="Next 30 days · site visits and inspections">
      <div className="mx-auto w-full max-w-[1000px] px-4 md:px-6 space-y-4" data-testid="site-visits-calendar">
        <div className="flex flex-wrap gap-2 items-end">
          <label htmlFor="cal-assignee" className="text-sm">Assignee
            <select id="cal-assignee" value={assignee} onChange={(e) => setAssignee(e.target.value)} className={INPUT} data-testid="cal-assignee">
              <option value="">Everyone</option>{users.map((u) => <option key={u.id} value={u.id}>{u.display_name || u.id.slice(0, 8)}</option>)}
            </select>
          </label>
          <button type="button" onClick={() => downloadIcs(`/site-visits/calendar.ics?${q()}`, "site-visits.ics").catch((e) => setErr(errMsg(e)))} className={`${BTN} bg-erf-dark text-white`} data-testid="cal-export">Export to calendar (.ics)</button>
        </div>
        {err && <p role="alert" className="text-sm text-red-700" data-testid="cal-error">{err}</p>}
        {rows === null && !err && <p className="font-mono text-xs" data-testid="cal-loading">Loading…</p>}
        {rows?.length === 0 && <p className="text-sm" data-testid="cal-empty">Nothing scheduled in the next 30 days.</p>}
        {Object.entries(groups).map(([d, vs]) => (
          <section key={d} className="border border-erf-borderCream rounded bg-white p-4" data-testid={`cal-day-${d}`}>
            <h2 className="font-display font-semibold mb-2">{d}</h2>
            <ul className="space-y-2">
              {vs.map((v) => (
                <li key={v.id} className={`text-sm ${v.status === "cancelled" ? "line-through text-erf-dark/50" : ""}`} data-testid={`cal-visit-${v.id}`}>
                  {fmt(v.scheduled_at)} · {v.kind === "inspection" ? "Inspection" : "Site visit"} · {v.duration_minutes}m · {v.status}
                  {v.location ? ` · ${v.location}` : ""}
                  {v.lead_id && <> · <Link to={`/crm/leads/${v.lead_id}`} className="underline" data-testid={`cal-lead-${v.id}`}>Lead</Link></>}
                  {v.opportunity_id && <> · <Link to={`/crm/opportunities/${v.opportunity_id}`} className="underline inline-flex min-h-[44px] items-center" data-testid={`cal-opp-${v.id}`}>Opportunity</Link></>}
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </AppShell>
  );
}
